import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const sshKeyTypeOptions = [
  { label: 'RSA', value: 'rsa' },
  { label: 'Ed25519', value: 'ed25519' },
  //   { label: 'ECDSA (Compact, less compatible)', value: 'ecdsa' },
  //   { label: 'DSA (Deprecated)', value: 'dsa' },
]

interface Props {}

export default function SSHKeyTypePicklist({
  name = 'sshKeyType',
  label = 'SSH Key Type',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return (
    <AsyncDropdown
      compact={compact}
      name={name}
      label={label}
      items={sshKeyTypeOptions}
      {...rest}
    />
  )
}
